import { __makeTemplateObject } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';
import { Button } from '../button/Button.js';
import { ProductPrice } from '../product-price/ProductPrice.js';
import { tint as curriedTint$1 } from '../../../node_modules/polished/dist/polished.esm.js';
import { defaultToolkitTheme } from '../theme/defaultToolkitTheme.js';
import '../theme/GlobalStyle.js';
import '../theme/ThemeProvider.js';
import { Text } from '../text/Text.js';
import { useResponsiveValue } from '../../hooks/use-match-media.js';

var CTAButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "PriceButton__CTAButton",
  componentId: "sc-sthvvv-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n\n  &:hover,\n  &:focus {\n      border-color: ", ";\n      background-color: ", ";\n    }\n  }\n  &.btn-is-loading {\n    color: rgba(255, 255, 255, 0);\n    background-color: #48a90f;\n    border-color: #48a90f;\n    transition: all 0.5s;\n    &:hover {\n      color: transparent;\n    }\n    &::before {\n      content: \"Loading ...\";\n      color: rgba(255, 255, 255, 0.7);\n      position: absolute;\n      left: 0;\n      right: 0;\n      animation: moveUp 0.5s;\n    }\n  }\n\n  @-webkit-keyframes moveUp {\n    0% {\n      -webkit-transform: translateY(50%);\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n      -webkit-transform: translateY(0);\n    }\n  }\n\n  @-moz-keyframes moveUp {\n    0% {\n      -moz-transform: translateY(50%);\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n      -moz-transform: translateY(0);\n    }\n  }\n\n  @keyframes moveUp {\n    0% {\n      transform: translateY(50%);\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n"], ["\n  position: relative;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n\n  &:hover,\n  &:focus {\n      border-color: ", ";\n      background-color: ", ";\n    }\n  }\n  &.btn-is-loading {\n    color: rgba(255, 255, 255, 0);\n    background-color: #48a90f;\n    border-color: #48a90f;\n    transition: all 0.5s;\n    &:hover {\n      color: transparent;\n    }\n    &::before {\n      content: \"Loading ...\";\n      color: rgba(255, 255, 255, 0.7);\n      position: absolute;\n      left: 0;\n      right: 0;\n      animation: moveUp 0.5s;\n    }\n  }\n\n  @-webkit-keyframes moveUp {\n    0% {\n      -webkit-transform: translateY(50%);\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n      -webkit-transform: translateY(0);\n    }\n  }\n\n  @-moz-keyframes moveUp {\n    0% {\n      -moz-transform: translateY(50%);\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n      -moz-transform: translateY(0);\n    }\n  }\n\n  @keyframes moveUp {\n    0% {\n      transform: translateY(50%);\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n"])), function (_a) {
  var borderColor = _a.borderColor;
  return curriedTint$1(0.1, borderColor);
}, function (_a) {
  var backgroundColor = _a.backgroundColor;
  return curriedTint$1(0.1, backgroundColor);
});
var SoldoutBtn = /*#__PURE__*/styled(Button).withConfig({
  displayName: "PriceButton__SoldoutBtn",
  componentId: "sc-sthvvv-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 48px;\n  color: ", ";\n  border-color: ", ";\n  background-color: ", ";\n  opacity: 0.5;\n  &:hover,\n  &:focus {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  span {\n    text-decoration: underline;\n  }\n"], ["\n  height: 48px;\n  color: ", ";\n  border-color: ", ";\n  background-color: ", ";\n  opacity: 0.5;\n  &:hover,\n  &:focus {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  span {\n    text-decoration: underline;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.text.button;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.disabled;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.disabled;
}, function (_a) {
  var theme = _a.theme;
  return curriedTint$1(0.1, theme.colors.greenLantern);
}, function (_a) {
  var theme = _a.theme;
  return curriedTint$1(0.1, theme.colors.disabled);
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.text.button;
});
var buttonFontSizes = {
  sm: 1,
  md: 2,
  lg: 3
};
var getButtonFontSize = function (size) {
  if (Array.isArray(size)) {
    return size.map(function (s) {
      return buttonFontSizes[s];
    });
  }
  return buttonFontSizes[size];
};
var PriceButton = function (_a) {
  var isAvailable = _a.isAvailable,
    _b = _a.size,
    size = _b === void 0 ? "sm" : _b,
    fullPrice = _a.fullPrice,
    displayPrice = _a.displayPrice,
    _c = _a.cta,
    cta = _c === void 0 ? "View" : _c,
    _d = _a.ctaBackgroundColor,
    ctaBackgroundColor = _d === void 0 ? defaultToolkitTheme.colors.greenLantern : _d,
    _e = _a.ctaBorderColor,
    ctaBorderColor = _e === void 0 ? defaultToolkitTheme.colors.greenLantern : _e,
    _f = _a.onClick,
    onClick = _f === void 0 ? function () {
      return console.warn("No onClick event defined for Price button");
    } : _f,
    _g = _a.isLoading,
    isLoading = _g === void 0 ? false : _g,
    _h = _a.color,
    color = _h === void 0 ? "white" : _h,
    _j = _a.hoverColor,
    hoverColor = _j === void 0 ? "white" : _j,
    _k = _a.notifyMeText,
    notifyMeText = _k === void 0 ? "" : _k;
  var buttonFontSize = getButtonFontSize(size);
  return React__default.createElement(Box, {
    display: "flex",
    border: "1px solid",
    borderColor: "disabled",
    borderRadius: 100
  }, isAvailable ? React__default.createElement(React__default.Fragment, null, React__default.createElement(Box, {
    display: "flex",
    flexWrap: "wrap",
    alignContent: "center",
    justifyContent: "center",
    px: "8px",
    flex: "1 1"
  }, React__default.createElement(ProductPrice, {
    size: size,
    price: displayPrice,
    rrp: fullPrice
  })), React__default.createElement(CTAButton, {
    onClick: onClick,
    variant: "primary",
    fontFamily: "heading",
    letterSpacing: "tight",
    px: "8px",
    margin: "-1px -1px -1px 0",
    flex: "1 1",
    fontSize: buttonFontSize,
    className: isLoading ? "btn-is-loading" : "",
    disabled: isLoading,
    backgroundColor: ctaBackgroundColor,
    borderColor: ctaBorderColor,
    color: color,
    hoverColor: hoverColor
  }, cta)) : React__default.createElement(SoldoutBtn, {
    variant: "primary",
    fontFamily: "heading",
    letterSpacing: "tight",
    px: "8px",
    py: "10px",
    margin: "-1px -1px -1px 0",
    flex: "1 1",
    disabled: notifyMeText ? false : true,
    fontSize: buttonFontSize,
    onClick: onClick
  }, "Sorry, Sold Out ", React__default.createElement("br", null), notifyMeText && React__default.createElement(Text, {
    as: "span",
    fontSize: "12px"
  }, useResponsiveValue(notifyMeText))));
};
var templateObject_1, templateObject_2;

export { PriceButton };
//# sourceMappingURL=PriceButton.js.map
